export enum ReadType {
    AggregatedValue,
    AggregatedValueList,
    AllValues
}